module.exports = __webpack_public_path__ + "assets/img/collect-cards-light2.51b92b8f.png";